module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_list_arrow-49d7d10e34baef873a94fce2794220fb.svg";